// One lock for overlapping dialogs; closing one cannot unlock another.
const owners = new Set();
let scrollY = 0;
function lock(owner) {
    if (owners.has(owner)) return;
    if (!owners.size) {
        scrollY = window.scrollY || document.documentElement.scrollTop || 0;
        document.documentElement.style.setProperty('--hm-overlay-scroll-top', `-${scrollY}px`);
        document.documentElement.classList.add('hm-overlay-locked');
        document.body.classList.add('hm-overlay-locked');
    }
    owners.add(owner);
}
function unlock(owner) {
    if (!owners.delete(owner) || owners.size) return;
    document.documentElement.classList.remove('hm-overlay-locked');
    document.body.classList.remove('hm-overlay-locked');
    document.documentElement.style.removeProperty('--hm-overlay-scroll-top');
    // Restore before paint, including when the document has smooth scrolling.
    const behavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, scrollY);
    document.documentElement.style.scrollBehavior = behavior;
}
window.HMScrollLock = { lock, unlock, get scrollY() { return scrollY; } };

function ready() {
    // Also cover native Blade dialogs and existing third-party popup integrations.
    const selectors = '.fancybox-container:not(.fancybox-is-closing), .hm-auth-modal.is-open, .hm-sheet.is-open, .hm-mobile-search-panel.is-open, .map-overlay.is-open';
    let scheduled = false;
    function sync() {
        scheduled = false;
        const active = !!document.querySelector(selectors)
            || document.body.matches('.nf-filter-open, .is-ad-list-map-open, .is-filters-open, .hm-mobile-menu-open, .lockscreen');
        if (active) lock('observed-dialog');
        else unlock('observed-dialog');
    }
    new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        queueMicrotask(sync);
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    if (window.jQuery) {
        window.jQuery(document).on('beforeShow.fb', () => lock('fancybox'));
        window.jQuery(document).on('afterClose.fb', () => {
            if (!document.querySelector('.fancybox-container:not(.fancybox-is-closing)')) unlock('fancybox');
        });
    }
    sync();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
else ready();
export { lock, unlock };
